export enum SignUpEvent {
  EmailSubmitted = "Email Submitted",
  CompanyNameSubmitted = "Company Name Submitted",
  CountrySubmitted = "Country Submitted",
  BusinessAgeSubmitted = "Business Age Submitted",
  RevenueSubmitted = "Revenue Submitted",
  BusinessSubtypeSubmitted = "Business Subtype Submitted",
  BusinessProblemsSubmitted = "Business Problems Submitted",
  CurrentSoftwareSubmitted = "Current Software Submitted",
  CountryNotSupportedShown = "Country Not Supported Shown",
  ContactInfoSubmitted = "Contact Info Submitted",
  FreeSignupSubmitted = "Free Signup Submitted",
  AccountConfirmationSubmitted = "Account Confirmation Submitted",
  CheckpointReached = "Checkpoint Reached",
  SignUpFailed = "Sign Up Failed",
  SignUpQualified = "Sign Up Qualified",
  SignUpDisqualified = "Sign Up Disqualified",
  DemoBooked = "Demo Booked",
  DemoSkipped = "Demo Skipped",
  CreatePasswordSubmitted = "Create Password Submitted",
}

/**
 * Revenue Hero Lifecycle Events
 * https://help.revenuehero.io/integrations/javascript-events
 */
export type RevenueHeroEvent =
  | "PAGE_LOADED"
  | "RH_SUBMITTING_SESSION"
  | "RESIZE_IFRAME"
  | "MEETING_BOOKED"
  | "PROSPECT_DISQUALIFIED"
  | "INIT_REDIRECT"
  | "CLOSE_DIALOG"
  | "RH_HIDE_LOADER";
